/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomVersionBase {
    getFixupPrototypeFunction() { return AppSecopsSbomVersionBase.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomVersionBase>): AppSecopsSbomVersionBase {
        let obj = Object.assign(new AppSecopsSbomVersionBase(), model);
        AppSecopsSbomVersionBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomVersionBase>): AppSecopsSbomVersionBase {
        if (!model) return null;
        return AppSecopsSbomVersionBase.newInstance(<AppSecopsSbomVersionBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomVersionBase) {
        if (!obj) return;

        models.AppSecopsSbomVersionBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomVersionBase): boolean {
        Object.setPrototypeOf(obj, AppSecopsSbomVersionBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.sbom_file_format) {
            models.AppSecopsSbomVersionFileFormat.fixupPrototype(this.sbom_file_format);
        }
    }

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * Unique ID of the SBOM
     */
    sbom_definition_id: string;

    /**
     * Unique ID of the attachment to identify the SBOM version file
     */
    attachment_id: string;

    /**
     * Unique ID of the build associated with the SBOM version
     */
    build_id: string;

    /**
     * File format of the SBOM version
     */
    sbom_file_format: models.AppSecopsSbomVersionFileFormat;

}
